<template>
  <modal :show.sync="showModal" size="xl" id="technological-index-modal">
    <template slot="header">
      <div>
        <h5 class="modal-title">Índice Tecnológico</h5>
      </div>
    </template>
    <collapse v-loading="isLoading" :multiple-active="false">
      <collapse-item v-for="(group, groupIndex) in groups" :key="groupIndex" wrapperClasses="">
        <template v-slot:title>
          <div>{{ group.description }} - {{ calcTechIndex(group.selectedProducts).toLocaleString('pt-BR', {style: 'currency', currency: 'brl'}) }}</div>
        </template>
        <div style="width: 100%; overflow-x: auto;">
          <el-table
            :data="group.preferredproducts"
            @selection-change="handleSelectionChange(group, $event)"
            class="table-responsive table-striped"
            ref="multipleTable"
            style="width: 100%; min-width: 1000px;">
            <el-table-column
              type="selection"
              sortable
              width="40">
            </el-table-column>
            <el-table-column
              prop="name"
              sortable
              label="Produto Preferencial"
              width="220">
            </el-table-column>
            <el-table-column v-slot="{ row, index }"
              label="Dose(HA)">
                <base-input
                  input-classes="form-control-sm"
                  :value="row.quantity"
                  @input="
                    $set(row, 'quantity', $event);
                    $set(groups, groupIndex, Object.assign({}, group, { preferredproducts: group.preferredproducts.map((product, productIndex) => productIndex === index ? Object.assign({}, product, { quantity: $event }) : product) }));
                    $refs.multipleTable[groupIndex].toggleRowSelection(row, true);
                    $nextTick(function () {
                      group.selectedProducts.forEach(preferredproduct => {
                        $refs.multipleTable[groupIndex].toggleRowSelection(preferredproduct, true)
                      })
                    })
                  "
                  mask="volume"
                  placeholder="Ex: 1,80">
                </base-input>
            </el-table-column>
            <el-table-column v-slot="{ row, index }"
              label="Aplicação">
                <base-input
                  input-classes="form-control-sm"
                  v-model="row.volume"
                  @input="
                    $set(row, 'volume', $event);
                    $set(groups, groupIndex, Object.assign({}, group, { preferredproducts: group.preferredproducts.map((product, productIndex) => productIndex === index ? Object.assign({}, product, { volume: $event }) : product) }));
                    $refs.multipleTable[groupIndex].toggleRowSelection(row, true)
                    $nextTick(function () {
                      group.selectedProducts.forEach(preferredproduct => {
                        $refs.multipleTable[groupIndex].toggleRowSelection(preferredproduct, true)
                      })
                    })
                  "
                  step="0.1"
                  mask="volume"
                  placeholder="Ex: 0,20">
                </base-input>
            </el-table-column>
            <el-table-column v-slot="{row}"
              label="Volume Total">
                <base-input
                input-classes="form-control-sm"
                :value="((row.volume || 0) * (row.quantity || 0)).toLocaleString('pt-BR')"
                :disabled="true">
              </base-input>
            </el-table-column>
            <el-table-column v-slot="{row}"
              label="Valor Unitário">
                <base-input
                  input-classes="form-control-sm"
                  :value="parseFloat(row.unitary_price).toLocaleString('pt-BR', {style: 'currency', currency: 'brl'})"
                  :disabled="true">
                </base-input>
            </el-table-column>
            <el-table-column v-slot="{row}"
              label="Custo por Ha">
                <base-input
                  input-classes="form-control-sm"
                  :value="((row.volume || 0) * (row.quantity || 0) * (row.unitary_price || 0)).toLocaleString('pt-BR', {style: 'currency', currency: 'brl'})"
                  :disabled="true">
                </base-input>
            </el-table-column>
          </el-table>
        </div>
      </collapse-item>
    </collapse>
    <template slot="footer">
      <base-button type="secondary" @click="showModal = false">Fechar</base-button>
      <base-button type="success"   @click="save">Salvar</base-button>
    </template>
  </modal>
</template>

<script>
import Collapse from '@/components/Collapse/Collapse'
import CollapseItem from '@/components/Collapse/CollapseItem'
import {Row, Table,TableColumn} from "element-ui";

export default {
  name: 'technological-index-modal',
  components: {
    Collapse,
    CollapseItem,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    cicle: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      groups: [
        {
          description: 'Agroquimicos',
          preferredproducts: [],
          selectedProducts: [],
        },
        {
          description: 'Nutrição',
          preferredproducts: [],
          selectedProducts: [],
        },
        {
          description: 'Sementes',
          preferredproducts: [],
          selectedProducts: [],
        },
        {
          description: 'Outros',
          preferredproducts: [],
          selectedProducts: [],
        },
      ],
    }
  },
    methods: {
    loadProducts() {
      this.isLoading = true
      this.$http.secured
        .get('/api/v1/cultures/' + this.cicle.culture.id, {params: {with_preferredproduct: true}})
        .then(response => {
          this.groups[0].preferredproducts = []
          this.groups[1].preferredproducts = []
          this.groups[2].preferredproducts = []
          this.groups[3].preferredproducts = []

          response.data.preferredproduct.forEach(preferredproduct => {
            let groupIndex = 3

            if(preferredproduct.grupo_id == 1) groupIndex = 0
            if(preferredproduct.grupo_id == 2) groupIndex = 1
            if(preferredproduct.grupo_id == 4) groupIndex = 2

            this.groups[groupIndex].preferredproducts.push(preferredproduct)

            const ti = this.cicle.technological_indexes.find(ti => ti.preferredproduct_id == preferredproduct.id)

            if(ti){
              preferredproduct.quantity = ti.quantity
              preferredproduct.volume   = ti.volume
              this.groups[groupIndex].selectedProducts.push(preferredproduct)
              this.$nextTick(function () {
                this.$refs.multipleTable[groupIndex].toggleRowSelection(preferredproduct, true)
              })
            }
          });
          this.isLoading = false
        })
        .catch(() => this.isLoading = false)
    },
    calcTechIndex(preferredproducts) {
      return preferredproducts.reduce((sum, preferredproduct) => sum + ((preferredproduct.volume || 0) * (preferredproduct.quantity || 0) * (preferredproduct.unitary_price || 0)), 0)
    },
    handleSelectionChange(group, preferredproducts) {
      group.selectedProducts = preferredproducts
    },
    technologicalIndexes() {
      const technologicalIndexes = this.cicle.technological_indexes
      const selectedProducts = this.groups.flatMap(group => group.selectedProducts)
      let indexesForDestruction = []

      technologicalIndexes.forEach(ti => {
        if(!selectedProducts.find(p => p.id == ti.preferredproduct_id)){
          ti._destroy = true
          indexesForDestruction.push(ti)
        }
      })

      return [
        ...selectedProducts.map(p => {
          const ti = technologicalIndexes.find(ti => (ti.preferredproduct_id == p.id))
          return {
            id: ti ? ti.id : null,
            quantity: p.quantity,
            volume: p.volume,
            preferredproduct_id: p.id,
          }
        }),
        ...indexesForDestruction,
      ]
    },
    save() {
      this.$http.secured
                .patch(`/api/v1/cultures/${this.cicle.culture.id}/cicles/${this.cicle.id}`, {
                  cicle: {
                    technological_indexes_attributes: this.technologicalIndexes()
                  }
                })
                .then(response => this.updateCicle(response.data))
    },
    updateCicle(cicle) {
      this.$emit('update:cicle', cicle)
      this.showModal = false
    },
  },
  watch: {
    show(newShow) {
      if(newShow) {
        this.loadProducts()
      }
    },
  },
  computed: {
    showModal: {
      get() {return this.show},
      set(modal) {this.$emit('update:show', modal)},
    },
  },
}
</script>

<style>
  #technological-index-modal .el-table .form-group {
    margin-bottom: 0 !important;
  }
</style>
